// Utility function to get window.location.search so we can mock it in our tests
// (otherwise jsdom complains about navigation changes)
export const getQueryString = () => window.location.search;

export default getQueryString;
